import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, submit, formValueSelector } from 'redux-form';
import InputField from './InputField';
import CheckboxField from './CheckboxField';
import SelectField from './SelectField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';
import { nullifyChoice } from '../helpers/normalizers';
import { idsByMake } from '../helpers/preactivations';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';

class DeviceForm extends React.Component {
  state = {
    isOpenModal: false,
  };

  handleSubmit = () => {
    const { icc_id } = this.props;
    if (icc_id && icc_id.length !== 20) {
      this.setState({ isOpenModal: true });
    } else {
      this.remoteSubmit();
    }
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  remoteSubmit = () => {
    this.props.dispatch(submit('device'));
  };

  render() {
    const { isOpenModal } = this.state;
    const {
      sub,
      handleSubmit,
      error,
      saveStatus,
      deviceDetails,
      isAdmin,
      SubNav,
      DeviceBar,
      heading,
      plans,
      isAtt,
      isTracfone,
      isSimo,
    } = this.props;
    const showForceOption =
      isAtt &&
      isAdmin &&
      sub &&
      sub.synced_with_att &&
      sub.att_status === 'active';
    const platformOpts = [
      ['ios', 'iOS'],
      ['android', 'Android'],
    ];
    let statusOpts = isTracfone
      ? [['foreign', 'Foreign Device']]
      : [
          ['wing', 'Wing Device'],
          ['loaner', 'Wing Loaner Device'],
        ];

    const makeOptions = Object.keys(idsByMake).map((make) => [make, make]);

    if (isAdmin) {
      statusOpts.push(['testing', 'Internal Testing Device']);
    }

    return (
      <div>
        <h1>{heading}</h1>
        <p>
          {SubNav && <SubNav />}
          {DeviceBar && <DeviceBar />}
        </p>
        <form onSubmit={handleSubmit}>
          {isSimo ? (
            <React.Fragment>
              <Field
                component={InputField}
                name="serial_number"
                label="Device SN"
              />
              <Field
                component={CheckboxField}
                name="sync"
                label="Device already active"
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Field
                component={InputField}
                name="device_id"
                label="Device ID"
              />
              <Field
                component={SelectField}
                name="device_make"
                label="Device Brand"
                options={makeOptions}
                empty="Select brand"
                normalize={nullifyChoice}
              />
              <Field
                component={SelectField}
                name="device_status"
                label="Device Status"
                options={statusOpts}
                empty="Select device status"
                normalize={nullifyChoice}
              />
            </React.Fragment>
          )}
          {!isTracfone && !isSimo && (
            <Field
              component={SelectField}
              name="platform"
              label="Platform"
              options={platformOpts}
              empty="Select platform"
              normalize={nullifyChoice}
            />
          )}
          {!isSimo && (
            <Field component={InputField} name="icc_id" label="ICC ID" />
          )}
          {plans && !isTracfone && !isAtt && (
            <Field
              component={SelectField}
              name="plan_id"
              label="Update plan"
              empty="Select plan"
              normalize={nullifyChoice}
              options={plans.map((plan) => [
                plan.id,
                `${plan.name} - $${plan.price}`,
              ])}
            />
          )}
          {!isTracfone && !isSimo && (
            <Field component={InputField} name="remark" label="Remark" />
          )}
          {showForceOption && (
            <Field component={CheckboxField} name="force" label="Force" />
          )}
          {error && <FormError error={error} />}
          <br />
          <button
            type="button"
            onClick={this.handleSubmit}
            className="btn btn-default"
            disabled={saveStatus === 'PENDING'}
          >
            Save Device
          </button>
          <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
          {deviceDetails && !isTracfone && (
            <div className="response-details">
              {Object.keys(deviceDetails).map((attr) => (
                <div key={attr}>
                  {attr}: {String(deviceDetails[attr])}
                </div>
              ))}
            </div>
          )}
        </form>
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm ICCID number"
          description={`Please revisit your ICCID number. It should be 20 digits long.`}
          onClose={this.closeModal}
          onConfirm={this.remoteSubmit}
        />
      </div>
    );
  }
}

const validate = (values, { isTracfone }) => {
  let errors = {};

  if (isTracfone) {
    if (!values.device_status) {
      errors.device_status = 'Required';
    }

    if (
      values.icc_id &&
      !(values.icc_id.length === 20 || values.icc_id.length === 19)
    ) {
      errors.icc_id = 'Please enter valid icc id';
    }
  }

  return errors;
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('device');
  return {
    icc_id: selector(state, 'icc_id'),
  };
};

const ConnectedDeviceForm = connect(mapStateToProps)(DeviceForm);

export default reduxForm({
  form: 'device',
  validate,
})(ConnectedDeviceForm);
